<script setup>
import SampleChadarManage from './sample-chadar-manage.vue'

definePage({
  meta: {
    subject: 'Sample Chadar',
  },
})
</script>

<template>
  <SampleChadarManage />
</template>
